import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditAssetsForm from './EditAssetsForm'
import ModalHeader from './ModalHeader'
import AssetsLoader from './_load/AssetsLoader'

const EditAssetsModal = props => {
  return (
    <ControlledModal fullScreen noPadding {...props}>
      <ModalHeader />
      <PermissionChecker module="place" name="edit">
        <AssetsLoader>
          <EditAssetsForm />
        </AssetsLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditAssetsModal
